import { render } from "./LoaderSpinner.vue?vue&type=template&id=1e4748f5&ts=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=ts"
export * from "./LoaderSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__